import {FormControl, MenuItem, Select, InputLabel} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {SelectChangeEvent} from '@mui/material';

interface OnlineFilterProps {
  onOnlineChange: (event: SelectChangeEvent<string>) => void;
  currentOnlineValue?: boolean | null;
}

const OnlineFilter: React.FC<OnlineFilterProps> = ({
  onOnlineChange,
  currentOnlineValue = null
}) => {
  const {t} = useTranslation();

  const value =
    currentOnlineValue === null
      ? 'all'
      : currentOnlineValue
      ? 'online'
      : 'offline';

  return (
    <FormControl fullWidth>
      <InputLabel id="online-events-label" shrink>
        {t('event_type')}
      </InputLabel>
      <Select
        labelId="online-events-label"
        value={value}
        label={t('event_type')}
        onChange={onOnlineChange}
      >
        <MenuItem value="all">{t('online_and_offline')}</MenuItem>
        <MenuItem value="online">{t('online')}</MenuItem>
        <MenuItem value="offline">{t('offline')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default OnlineFilter;
